import * as C from "../constants/aboutConstants";

export const aboutDetailsReducer = (state = { about: {} }, action) => {
  switch (action.type) {
    case C.ABOUT_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case C.ABOUT_DETAILS_SUCCESS:
      return {
        loading: false,
        about: action.payload,
      };

    case C.ABOUT_DETAILS_FAIL:
      return {
        loading: false,
        error: action.payload,
        about: {},
      };

    default:
      return state;
  }
};

export const aboutAdminDetailsReducer = (state = { about: {} }, action) => {
  switch (action.type) {
    case C.ABOUT_ADMIN_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case C.ABOUT_ADMIN_DETAILS_SUCCESS:
      return {
        loading: false,
        about: action.payload,
      };

    case C.ABOUT_ADMIN_DETAILS_FAIL:
      return {
        loading: false,
        error: action.payload,
        about: {},
      };

    default:
      return state;
  }
};

export const aboutUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.ABOUT_UPDATE_REQUEST:
      return { loading: true };

    case C.ABOUT_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        about: action.payload,
      };

    case C.ABOUT_UPDATE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case C.ABOUT_UPDATE_RESET:
      return {};

    default:
      return state;
  }
};

export const aboutDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case C.ABOUT_DELETE_REQUEST:
      return { loading: true };

    case C.ABOUT_DELETE_SUCCESS:
      return {
        loading: false,
        success: true,
        message: action.payload?.message || "About page removed",
      };

    case C.ABOUT_DELETE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case C.ABOUT_DELETE_RESET:
      return {};

    default:
      return state;
  }
};
